import { render, staticRenderFns } from "./EventMain.vue?vue&type=template&id=28b6a4fc&scoped=true&"
import script from "./EventMain.vue?vue&type=script&lang=js&"
export * from "./EventMain.vue?vue&type=script&lang=js&"
import style0 from "./EventMain.vue?vue&type=style&index=0&id=28b6a4fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b6a4fc",
  null
  
)

export default component.exports